
import { RevCard } from '@ds/components/Card'

import ReviewsLegalModal from '../../ReviewsLegalModal'
import RateSection from '../RateSection'

import Stats from './Stats'

export default {
  components: {
    RevCard,
    Stats,
    RateSection,
    ReviewsLegalModal,
  },
  props: {
    globalRate: {
      type: Number,
      required: true,
    },
    totalReviews: {
      type: Number,
      required: true,
    },
    statsInfo: {
      type: Array,
      default: () => [],
    },
  },
}
